import * as THREE from 'three';


export function add_light(scene, renderer){

  /*
  // 🌤️ Luz ambiental clara con un toque cálido
scene.add(new THREE.AmbientLight(0xfff9e6, 1.0)); // sin cambio

// 🌞 Luz principal (sol bajo, brillante y más intensa) — lado opuesto
const sunLight = new THREE.DirectionalLight(0xfff4cc, 3.4);
sunLight.position.set(6, 1.2, 3); // ← antes (-6, 1.2, -3)
sunLight.castShadow = true;
sunLight.shadow.bias = -0.0001;
scene.add(sunLight);

// 💨 Luz de cielo fría para sombras equilibradas — lado opuesto
const skyLight = new THREE.DirectionalLight(0xe0f0ff, 0.8);
skyLight.position.set(-3, 2, -5); // ← antes (3, 2, 5)
scene.add(skyLight);

// ✨ Luz trasera blanca para reflejos suaves — lado opuesto
const backLight = new THREE.DirectionalLight(0xffffff, 0.45);
backLight.position.set(-2, 0.5, 2); // ← antes (2, 0.5, -2)
scene.add(backLight);

// 🌫️ Niebla cálida (profundidad realista)
scene.fog = new THREE.Fog(0xfffae6, 12, 100);
  */


// ☀️ MEDIODÍA — iluminación súper brillante, azulada y clara
// ------------------------------------------------------------------

// Luz ambiental muy clara y amplia (luz general del cielo)
const ambientLight = new THREE.AmbientLight(0xffffff, 1.1);
scene.add(ambientLight);

// Luz solar principal (sol arriba, casi cenital)
const sunLight = new THREE.DirectionalLight(0xffffff, 3.5);
sunLight.position.set(20, 40, 10); // sol alto
sunLight.castShadow = true;

sunLight.shadow.bias = -0.0003;
sunLight.shadow.mapSize.width = 4096;
sunLight.shadow.mapSize.height = 4096;
scene.add(sunLight);

// Luz del cielo azul (reflejo natural del mediodía)
const skyLight = new THREE.HemisphereLight(0xbbe9ff, 0xffffff, 1.2);
// 0xbbe9ff = azul cielo brillante
scene.add(skyLight);

// Luz de rebote suave desde el suelo/mar
const bounceLight = new THREE.DirectionalLight(0xffffff, 0.4);
bounceLight.position.set(0, -1, 0);
scene.add(bounceLight);

// Luz trasera para dar volumen
const backLight = new THREE.DirectionalLight(0xffffff, 0.7);
backLight.position.set(-12, 8, 12);
scene.add(backLight);

// 🎨 Fondo y atmósfera de mediodía claro
scene.fog = new THREE.FogExp2(0xbbe9ff, 0.015); // niebla MUY suave
renderer.setClearColor(0x99d8ff); // color del cielo al mediodía

// 📸 Ajustes de tono para realismo de luz fuerte
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.35; // más brillante y definido
renderer.outputColorSpace = THREE.SRGBColorSpace;



}
